import React, {useState} from 'react'
import { LockClosedIcon } from '@heroicons/react/solid'
import { useDispatch } from 'react-redux'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import { login } from '../features/userSlice'
import Parse from 'parse/dist/parse.min.js';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'


export default function SingIn() {
    const [loading, setLoading] = useState(false)
    const dispatch  = useDispatch()
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            email:'',
            password:'',
            showPassword:'',
        },
        validationSchema: Yup.object({
          email: Yup.string().required('Campo requerido'),
          password: Yup.string().min(8).required()
        }),
        onSubmit: async (data) => {
          setLoading(true)
          await Parse.User.logIn(data.email,data.password)
          .then(async (user) => {            
            console.log(user.get('email')) 
           if(user.get('email') === 'amatamoros921029@gmail.com') {
            dispatch(login({
              email: data.email,
              loggedIn: true,
            }))  
            navigate('/add-business/')  
           }
            
            setLoading(false)
             
                                   
          })
          .catch((error) => {
             setLoading(false)
            console.log(error)
           
          });
          
        }
    })



   

  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-50">
        <body class="h-full">
        ```
      */}
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <img
              className="mx-auto h-20 w-auto"
              src="https://parsefiles.back4app.com/iMDjJAPDYIcx09KO3DIiD9MbhayTDY9i3dpmFrnC/ce0431df5be7f55dc594ca2075f1878a_logo_budgie.png"
              alt="Workflow"
            />
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Inicia sesión con tu cuenta</h2>
          
          </div>
          <form className="mt-8 space-y-6" action="#" method="POST" onSubmit={formik.handleSubmit}>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="email" className="sr-only">
                 Correo eletrónico
                </label>
                <input
                  type="email"
                  id='email'
                  autoComplete="email"             
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 focus:z-10 sm:text-sm"
                  placeholder="Correo eletrónico"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Contraseña
                </label>
                <input                
                  type={formik.values.showPassword[0] !== undefined ? 'text' : 'password' }
                  id='password'                 
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-cyan-500 focus:border-cyan-500 focus:z-10 sm:text-sm"
                  placeholder="Contraseña"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                />
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <input
                  id="showPassword"
                  name="showPassword"
                  onChange={formik.handleChange}
                  type="checkbox"
                  className="h-4 w-4 text-cyan-600 focus:ring-cyan-500 border-gray-300 rounded"
                />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                {formik.values.showPassword[0] !== undefined ? 'Ocultar Contraseña' : 'Mostar Contraseña'}  
                </label>
              </div>

             {/* 
             <div className="text-sm">
                <a href="#" className="font-medium text-cyan-600 hover:text-cyan-500">
                  Forgot your password?
                </a>
              </div>
              */}
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-cyan-300 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
              >
              { loading ?
               <span className="absolute left-0 inset-y-0 flex items-center pl-3  ">
                 <FontAwesomeIcon icon={faSpinner} size='lg' className='animate-spin' />
                 </span>
               :  
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <LockClosedIcon className="h-5 w-5 text-cyan-500 group-hover:text-cyan-300" aria-hidden="true" />
                </span>}
                Iniciar
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}
